import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { GearsApiService } from './gearsapi.service';

@Injectable({
  providedIn: 'root'
})
export class TaskServiceService {

  constructor(private title:Title, private meta:Meta, private apiService:GearsApiService) { }
  navbarbutton: any;

public titleUpdate(module:any, site:any, currentMeta:any = null){
  if (module && site) {
    this.apiService
      .get('StateMeta', {
        SiteID_FK: site,
        Module: module,
        Active: 1,
        Deleted: 0,
        OrderBy: '',
        PageSize: 1,
        PageNumber: 1,
      })
      .then((stateMeta: any) => {
        let contentString;
        let ogContentString;
        if (stateMeta.body.length > 0) {
          stateMeta = stateMeta.body[0];
          let string = (`${currentMeta[0].stocktype} ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${currentMeta[0].series} For Sale ${currentMeta[0].region} ${currentMeta[0].price} | ${currentMeta[0].sitename}`).replace(/\s{2,}/g, " ");
          contentString = currentMeta ? string : stateMeta.Title;
          this.title.setTitle(contentString || module);
          this.meta.updateTag({
            name: 'og:title',
            content: contentString || module,
          });
          this.meta.updateTag({
            name: 'twitter:title',
            content: contentString || module,
          });
          
          let keywordsString = '';
          if (currentMeta[0].series != 'Cars' || 'Trucks') {
            keywordsString += ', ' + currentMeta[0].series + ' Vehicles';
          }
          if (currentMeta[0].transmission) {
            keywordsString += ', ' + currentMeta[0].transmission + ' Vehicles';
          }
          if (currentMeta[0].stocktype) {
            keywordsString += ', ' + currentMeta[0].stocktype + ' Vehicles';
          }
          if (currentMeta[0].make) {
            keywordsString += ', ' + currentMeta[0].make + ' Vehicles';
          }
          if (currentMeta[0].fueltype) {
            keywordsString += ', ' + currentMeta[0].fueltype + ' Vehicles';
          }
          if (currentMeta[0].bodytype) {
            keywordsString += ', ' + currentMeta[0].bodytype + ' Vehicles';
          }
          if (currentMeta[0].region) {
            keywordsString += ', in ' + currentMeta[0].region;
          }
          if (currentMeta[0].price) {
            keywordsString += ', ' + currentMeta[0].price;
          }

          this.meta.updateTag({
            name: 'keywords',
            content: stateMeta.Keywords + keywordsString,
          });
          this.meta.updateTag({
            name: 'og:keywords',
            content: stateMeta.Keywords,
          });
          let region = currentMeta[0].region != "" ? currentMeta[0].region : 'our dealerships nationwide';
          let model = (currentMeta[0].series != 'Cars' || currentMeta[0].series != 'Trucks') ? currentMeta[0].series : 'models';
          if (currentMeta[0].stocktype == 'New' || currentMeta[0].stocktype == 'Commercials') {
            contentString = (`Explore our extensive selection of new ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${model} at ${currentMeta[0].sitename} across ${region} ${currentMeta[0].price}.`).replace(/\s{2,}/g, " ");
            ogContentString = (`Explore our extensive selection of new ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${model}, like the ${currentMeta[1]} at ${currentMeta[0].sitename} across ${region} ${currentMeta[0].price}.`).replace(/\s{2,}/g, " ");
          } else if (currentMeta[0].stocktype == 'Used') {
            contentString = (`Browse reliable used ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${currentMeta[0].series} for sale at ${currentMeta[0].sitename}. Quality-assured pre-owned vehicles available across ${region} ${currentMeta[0].price}.`).replace(/\s{2,}/g, " ");
            ogContentString = (`Browse reliable used ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${currentMeta[0].series}, like the ${currentMeta[1]} for sale at ${currentMeta[0].sitename}. Quality-assured pre-owned vehicles available across ${region} ${currentMeta[0].price}.`).replace(/\s{2,}/g, " ");
          } else if (currentMeta[0].stocktype == 'Demo') {
            contentString = (`Discover low-mileage demo ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${currentMeta[0].series} at ${currentMeta[0].sitename}. Great value and nearly new models now available across ${region} ${currentMeta[0].price}.`).replace(/\s{2,}/g, " ");
            ogContentString = (`Discover low-mileage demo ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${currentMeta[0].series}, like the ${currentMeta[1]} at ${currentMeta[0].sitename}. Great value and nearly new models now available across ${region} ${currentMeta[0].price}.`).replace(/\s{2,}/g, " ");
          } else if (currentMeta[0].stocktype == 'Specials') {
            contentString = (`View the latest ${currentMeta[0].make} ${currentMeta[0].series} specials at ${currentMeta[0].sitename}. Save on new, demo, and used ${currentMeta[0].make} with limited-time deals across ${region}.`).replace(/\s{2,}/g, " ");
            ogContentString = (`View the latest ${currentMeta[0].make} ${currentMeta[0].series} specials at ${currentMeta[0].sitename}. Save on new, demo, and used ${currentMeta[0].make}, like the ${currentMeta[1]}, with limited-time deals across ${region}.`).replace(/\s{2,}/g, " ");
          } else if (currentMeta[0].stocktype == 'All') {
            contentString = (`Buy New, Used and Demo cars, genuine parts, and expert service for all ${currentMeta[0].make} ${currentMeta[0].transmission} ${currentMeta[0].fueltype} ${currentMeta[0].bodytype} ${model} at ${currentMeta[0].sitename} across ${region} ${currentMeta[0].price}.`).replace(/\s{2,}/g, " ");
            ogContentString = (`Buy New, Used and Demo cars, genuine parts, and expert service for all ${currentMeta[0]?.make} ${currentMeta[0]?.transmission} ${currentMeta[0]?.fueltype} ${currentMeta[0]?.bodytype} ${model}, like the ${currentMeta[1]} at ${currentMeta[0]?.sitename} across ${region} ${currentMeta[0]?.price}.`).replace(/\s{2,}/g, " ");
          } else {
            contentString = stateMeta.Description;
            ogContentString = stateMeta.Description;
          }
          this.meta.updateTag({
            name: 'description',
            content: contentString,
          });
          this.meta.updateTag({
            name: 'og:description',
            content: ogContentString,
          });
          this.meta.updateTag({
            name: 'twitter:description',
            content: ogContentString,
          });
          this.meta.updateTag({ name: 'og:url', content: window.location.href || 'Bidvest McCarthy' });
        }
      });
  }
}

  public navUpdate(input="") {
    if(input!="") {
      this.navbarbutton = input;
    }
    else {
      switch(true){
        case window.location.pathname?.includes('/dealership'):
          this.navbarbutton = "contactus";
          break;
        case window.location.pathname?.includes('/parts'):
          this.navbarbutton = "parts";
          break;
        case window.location.pathname?.includes('/service'):
          this.navbarbutton = "service";
          break;
        case window.location.pathname?.includes('/buy'): {
          switch(true) {
            case window.location.search?.includes('type=new') || window.location.pathname?.includes('/new'):
              this.navbarbutton = "new";
              break;
            case window.location.search?.includes('type=used') || window.location.pathname?.includes('/used'):
              this.navbarbutton = "used";
              break;
            case window.location.search?.includes('type=demo') || window.location.pathname?.includes('/demo'):
              this.navbarbutton = "demo";
              break;
            case window.location.search?.includes('type=commercial') || window.location.pathname?.includes('/commercial'):
              this.navbarbutton = "commercial";
              break;
            case window.location.search?.includes('type=special') || window.location.pathname?.includes('/special'):
              this.navbarbutton = "specials";
              break;
            default:
              this.navbarbutton = "";
              break;
          }
          break;
        }
        default:
          this.navbarbutton = "home";
          break;
      }
    }
  }
}
